export default "__VITE_ASSET__88e7779c__"